/**
 * Centralized API Configuration
 *
 * This file provides the base URLs for all API calls.
 *
 * Development (localhost:3000): Uses environment variables
 * Production: Automatically derives from browser's current origin
 */

/**
 * Check if we're running in development (localhost:3000)
 */
const isDevelopment = (): boolean => {
  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    return (
      origin.includes("localhost:3001") ||
      origin.includes("localhost:3000") ||
      origin.includes("127.0.0.1:3000") ||
      origin.includes("https://main.zournalhq.com")
    );
  }
  // Fallback: check NODE_ENV if window is not available
  return process.env.NODE_ENV === "development";
};

/**
 * Get the base URL for API calls
 */
const getBaseUrl = (): string => {
  if (isDevelopment()) {
    // In development, use environment variables
    return (
      process.env.REACT_APP_API_SERVER_END_POINT || "http://localhost:8080"
    );
  }

  // In production, use browser's origin
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  // Fallback
  return process.env.REACT_APP_API_SERVER_END_POINT || "http://localhost:8090";
};

const BASE_URL = getBaseUrl();

/**
 * Backend API Base URL
 *
 * Development: Uses REACT_APP_API_SERVER_END_POINT from .env
 * Production: Uses browser origin + /backend
 * Example: https://main.zournalhq.com/backend
 */
export const API_BASE_URL = isDevelopment()
  ? BASE_URL // In dev, BASE_URL already contains the full backend URL
  : `${BASE_URL}/backend`;
